import React, { useEffect, useState } from "react";
import { Table, Form, Card, Row, Col, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import AppButton from "../../../AppButton";
import "../../../../style/addrestoration.css";
import "../../../../style/addmaterial.css";
import { apiAxios } from "../../../../utils/apiAxios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// FIXED INTERFACE
interface Material {
  processingTime: string;
  millingTime: string;
  materialID: number;
  materialName: string;
  orderTypeID: number;
  designingTime: string;
  unit: "minutes" | "days"; // store unit
  price: number; // price MUST BE NUMBER
  orderTypeName: string;
  warrantyMonths: number;
  designCost: number;
  millingCost: number;
  deliverTime: number;
  deliveryCost: number;
}

interface OrderType {
  orderTypeID: number;
  orderTypeName: string;
  acceptanceTiming: string;
  maximumCapacity: string;
  isActive: boolean;
  turnaroundTimeUnit: number;
  turnaroundTimeValue: number;
}

const AddMaterial: React.FC = () => {
  const [durationUnit, setDurationUnit] = useState<"minutes" | "days">("minutes");
  const [editUnit, setEditUnit] = useState<"minutes" | "days">("minutes"); // for edit mode
  const [materialName, setMaterialName] = useState("");
  const [materials, setMaterials] = useState<Material[]>([]);
  const [editId, setEditId] = useState<number | null>(null);

  const [ProcessingTime, setProcessingTime] = useState("");
  const [MillingDuration, setMillingDuration] = useState("");
  const [duration, setDuration] = useState("");
  const [price, setPrice] = useState<number | "">("");
  const [selectedOrderTypeId, setSelectedOrderTypeId] = useState<number | "">("");
  const [editOrderTypeId, setEditOrderTypeId] = useState<number | null>(null);
  const [warrantyMonths, setWarrantyMonths] = useState<number | "">("");
const [editWarrantyMonths, setEditWarrantyMonths] = useState<number | "">("");

  const [editValue, setEditValue] = useState("");
  const [editDuration, seteditDuration] = useState("");
  const [editMillingDuration, seteditMillingDuration] = useState("");
  const [editProcessingTime, seteditProcessingTime] = useState("");
  const [editPrice, setEditPrice] = useState<number | "">("");
  const [designCost, setDesignCost] = useState<number | "">("");
const [millingCost, setMillingCost] = useState<number | "">("");
//const [deliverTime, setDeliverTime] = useState<number | "">("");
const [deliveryCost, setDeliveryCost] = useState<number | "">("");
const [deliverTime, setDeliverTime] = useState("");
const [editDeliverTime, setEditDeliverTime] = useState("");
const [editDesignCost, setEditDesignCost] = useState<number | "">("");
const [editMillingCost, setEditMillingCost] = useState<number | "">("");
//const [editDeliverTime, setEditDeliverTime] = useState<number | "">("");
const [editDeliveryCost, setEditDeliveryCost] = useState<number | "">("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  const [orderTypes, setOrderTypes] = useState<OrderType[]>([]);
  const fetchOrderTypes = async () => {
    try {
      const response = await apiAxios.get(`${API_BASE}/OrderTypeMaster/GetAll`);
      const data = response.data;

      setOrderTypes(data.singleData || []);
    } catch (err) {
      console.warn("Fetch Error:", err);
    }
  };
  // Fetch All
  const fetchMaterials = async () => {
    try {
      const res = await apiAxios.get(`${API_BASE}/Material/GetAll`);
      const data = res.data;

      if (data.isSuccess && Array.isArray(data.singleData)) {
        console.log (data,"***");
       setMaterials(
  data.singleData.reverse().map((m: any) => ({
    ...m,
    price: Number(m.price || 0),
    warrantyMonths: Number(m.warrantyMonths || 0), // ✅ ADD
      deliverTime: Number(
            m.deliverTime ?? m.DeliverTime ?? 0
          ),

          deliveryCost: Number(
            m.deliveryCost ?? m.DeliveryCost ?? 0
          ),

          designingTime: String(
            m.designingTime ?? m.DesigningTime ?? 0
          ),

          millingTime: String(
            m.millingTime ?? m.MillingTime ?? 0
          ),
  }))
);
      }
    } catch (err) {
      console.warn("Fetch Error:", err);
    }
  };

  useEffect(() => {
    fetchOrderTypes();
    fetchMaterials();
  }, []);

  // Add Material
  const handleAdd = async () => {
    if (!materialName.trim()) {
      toast.warning("Enter valid material name");
      return;
    }

    if (duration === "" || Number(duration) < 0) {
      toast.warning("Enter valid duration");
      return;
    }
    if (price === "" || Number(price) < 0) {
      toast.warning("Enter valid price");
      return;
    }
    if (warrantyMonths === "" || Number(warrantyMonths) < 0) {
  toast.warning("Enter valid warranty in months");
  return;
}
    if (selectedOrderTypeId === "") {
      toast.warning("Please select an Order Type");
      return;
    }
    const durationInMinutes = durationUnit === "days" ? Number(duration) * 24 * 60 : Number(duration);
    const durationInMinutesMilling = durationUnit === "days" ? Number(MillingDuration) * 24 * 60 : Number(MillingDuration);
    const durationInMinutesdesigning = durationUnit === "days" ? Number(ProcessingTime) * 24 * 60 : Number(ProcessingTime);
    const res = await apiAxios.post(`${API_BASE}/Material/Create`, {
      materialName,
      DesigningTime: durationInMinutes,
      MillingTime: durationInMinutesMilling,
      warrantyMonths: Number(warrantyMonths),
      ProcessingTime: durationInMinutesdesigning,
      price: Number(price),
      Unit: durationUnit,
      OrderTypeID: selectedOrderTypeId,
      DesignCost: Number(designCost),
  MillingCost: Number(millingCost),
  DeliverTime: Number(deliverTime),
  DeliveryCost: Number(deliveryCost),
    });

    const result = res.data;

    if (result.isSuccess) {

      const selectedOrderType = orderTypes.find(
        (ot) => ot.orderTypeID === selectedOrderTypeId
      );

      setMaterials([
  {
    ...result.singleData,
    price: Number(result.singleData.price),
    warrantyMonths: Number(result.singleData.warrantyMonths || warrantyMonths || 0),
      designCost: Number(
    result.singleData.designCost || designCost || 0
  ),

  millingCost: Number(
    result.singleData.millingCost || millingCost || 0
  ),

  deliverTime: Number(
    result.singleData.deliverTime || deliverTime || 0
  ),

  deliveryCost: Number(
    result.singleData.deliveryCost || deliveryCost || 0
  ),

    orderTypeName: selectedOrderType?.orderTypeName || "",
  },
  ...materials,
]);
      toast.success("Material added!");

      setMaterialName("");
      setDuration("");
      setPrice("");
      setWarrantyMonths("");
      setSelectedOrderTypeId("");
      setMillingDuration("");   // ✅ clear nesting + milling
      setProcessingTime("");    // ✅ clear processing
      setDesignCost("");
setMillingCost("");
setDeliverTime("");
setDeliveryCost("");
    }
  };

  const handleEdit = (item: Material) => {
    setEditId(item.materialID);
    setEditValue(item.materialName);

    // IMPORTANT: force minutes
    setEditUnit("minutes");

    // set total minutes directly
    seteditDuration(String(item.designingTime));
    seteditMillingDuration(String(item.millingTime));
    seteditProcessingTime(String(item.processingTime));
    setEditOrderTypeId(item.orderTypeID); // from API response
    setEditPrice(item.price);
    setEditWarrantyMonths(item.warrantyMonths ?? 0);
     setEditDesignCost(
    Number(item.designCost || 0)
  );

  setEditMillingCost(
    Number(item.millingCost || 0)
  );

 setEditDeliverTime(String(item.deliverTime || 0));

  setEditDeliveryCost(
    Number(item.deliveryCost || 0)
  );  
  };



  // Update Material
  const handleUpdate = async () => {
    if (!editValue.trim() || editId === null) return;
    if (editPrice === "" || Number(editPrice) < 0) {
      toast.warning("Enter valid price");
      return;
    }
    if (editWarrantyMonths === "" || Number(editWarrantyMonths) < 0) {
  toast.warning("Enter valid warranty in months");
  return;
}

    const durationInMinutes = toStorageDuration(Number(editDuration), editUnit);
    const durationInMinutesMilling = toStorageDuration(Number(editMillingDuration), editUnit);
    const durationInMinutesdesigning = toStorageDuration(Number(editProcessingTime), editUnit);
    const res = await apiAxios.put(`${API_BASE}/Material/Update`, {
      materialID: editId,
      materialName: editValue,
      DesigningTime: durationInMinutes,
      MillingTime: durationInMinutesMilling,
      ProcessingTime: durationInMinutesdesigning,
      warrantyMonths: Number(editWarrantyMonths),
      price: Number(editPrice),
      unit: editUnit,
      OrderTypeID: editOrderTypeId,
      DesignCost: Number(editDesignCost),
    MillingCost: Number(editMillingCost),
    DeliverTime: Number(editDeliverTime),
    DeliveryCost: Number(editDeliveryCost),
    });

    const result = res.data;


    if (result.isSuccess) {
    setMaterials(
  materials.map((m) =>
    m.materialID === editId
      ? {
          ...m,
          materialName: editValue,
          designingTime: String(durationInMinutes),
          millingTime: String(durationInMinutesMilling),
          processingTime: String(durationInMinutesdesigning),
          price: Number(editPrice),
          warrantyMonths: Number(editWarrantyMonths),   // ✅ ADD
           designCost: Number(editDesignCost),
      millingCost: Number(editMillingCost),
      deliverTime: Number(editDeliverTime),
      deliveryCost: Number(editDeliveryCost),
          unit: editUnit,
          orderTypeID: editOrderTypeId || m.orderTypeID,
          orderTypeName:
            orderTypes.find((ot) => ot.orderTypeID === editOrderTypeId)?.orderTypeName ||
            m.orderTypeName,
        }
      : m
  )
);
      toast.success("Material updated!");
      await fetchMaterials();
      setEditId(null);
    }
  };

  // Cancel Edit
  const handleCancel = () => {
    setEditId(null);
  };

  // Delete Confirm
  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // Delete Material
  const handleDelete = async () => {
    if (!deleteId) return;

    const res = await apiAxios.delete(`${API_BASE}/Material/Delete/${deleteId}`);

    const result = res.data;

    if (result.isSuccess) {
      setMaterials(materials.filter((m) => m.materialID !== deleteId));
      toast.success("Material deleted!");
    }

    setShowDeleteModal(false);
    setDeleteId(null);
  };

  return (
    <div className="mt-3">
      <h4 className="mb-4">Add Material</h4>
      {/* ADD FORM */}
      <div className="premium-card mt-2">


        <Row className="row">
          {/* MATERIAL NAME */}
          <Col md={4} className="mb-4">
            <label className="form-label">Material Name</label>
            <Form.Control
              placeholder="Material Name"
              className="rounded-3 py-2"
              value={materialName}
              onChange={(e) => setMaterialName(e.target.value)}
            />
          </Col>
          <Col md={4} className="mb-4">
  <label className="form-label">Warranty (Months)</label>
  <Form.Control
    type="number"
    placeholder="Warranty in months"
    className="rounded-3 py-2"
    value={warrantyMonths}
    min={0}
    onChange={(e) =>
      setWarrantyMonths(e.target.value === "" ? "" : Number(e.target.value))
    }
  />
</Col>
          {/* PRICE */}
          <Col md={4} className="mb-4">
            <label className="form-label">Price Per Crown</label>
            <Form.Control
              type="number"
              placeholder="Price (₹)"
              className="rounded-3 py-2"
              value={price}
              onChange={(e) =>
                setPrice(e.target.value === "" ? "" : Number(e.target.value))
              }
            />
          </Col>
          {/* TURNAROUND TIME */}
             {/* ORDER TYPE DROPDOWN */}
          <Col md={4} className="mb-4">
            <Form.Group>
              <label className="form-label">Order Type</label>
              <Form.Select
                className="rounded-3  py-2"
                value={selectedOrderTypeId}
                onChange={(e) =>
                  setSelectedOrderTypeId(
                    e.target.value === "" ? "" : Number(e.target.value)
                  )
                }
              >
                <option value="">Select Order Type</option>

                {orderTypes.map((ot) => (
                  <option key={ot.orderTypeID} value={ot.orderTypeID}>
                    {ot.orderTypeName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={4} className="mb-4">
            <label className="form-label">Designing Time</label>
            <Form.Group>


              {durationUnit === "minutes" ? (
                <DurationTimePicker
                  value={Number(duration) || 0}
                  onChange={(mins) => setDuration(String(mins))}
                />
              ) : (
                <Form.Control
                  type="number"
                  placeholder="Turnaround Time (days)"
                  value={duration}
                  className="rounded-3 py-2"
                  onChange={(e) => setDuration(e.target.value)}
                />
              )}



            </Form.Group>
          </Col>

          {/* Milling Duration */}
          <Col md={4} className="mb-4">
            <label className="form-label">NESTING + Milling Time</label>
            <Form.Group>


              {durationUnit === "minutes" ? (
                <DurationTimePicker
                  value={Number(MillingDuration) || 0}
                  onChange={(mins) => setMillingDuration(String(mins))}
                />
              ) : (
                <Form.Control
                  type="number"
                  placeholder="Milling Time"
                  value={duration}
                  className="rounded-3 py-2"
                  onChange={(e) => setMillingDuration(e.target.value)}
                />
              )}



            </Form.Group>
          </Col>


          {/* Milling Duration */}
          <Col md={4} className="mb-4">
            <Form.Group>
              <label className="form-label">Processing Time</label>

              {durationUnit === "minutes" ? (
                <DurationTimePicker
                  value={Number(ProcessingTime) || 0}
                  onChange={(mins) => setProcessingTime(String(mins))}
                />
              ) : (
                <Form.Control
                  type="number"
                  placeholder="Milling Time"
                  value={duration}
                  className="rounded-3 py-2"
                  onChange={(e) => setProcessingTime(e.target.value)}
                />
              )}



            </Form.Group>
          </Col>
{/* DESIGN COST */}
<Col md={4} className="mb-4">
  <label className="form-label">Design Cost (₹)</label>

  <Form.Control
    type="number"
    min={0}
    placeholder="Design Cost (₹)"
    className="rounded-3 py-2"
    value={designCost}
    onChange={(e) =>
      setDesignCost(
        e.target.value === "" ? "" : Number(e.target.value)
      )
    }
  />
</Col>

{/* MILLING COST */}
<Col md={4} className="mb-4">
  <label className="form-label">Milling Cost (₹)</label>

  <Form.Control
    type="number"
    min={0}
    placeholder="Milling Cost (₹)"
    className="rounded-3 py-2"
    value={millingCost}
    onChange={(e) =>
      setMillingCost(
        e.target.value === "" ? "" : Number(e.target.value)
      )
    }
  />
</Col>

<Col md={4} className="mb-4">
  <label className="form-label">Delivery Time</label>

  <DurationTimePicker
    value={Number(deliverTime) || 0}
    onChange={(mins) => setDeliverTime(String(mins))}
  />
</Col>

{/* DELIVERY COST */}
<Col md={4} className="mb-4">
  <label className="form-label">Delivery Cost (₹)</label>

  <Form.Control
    type="number"
    min={0}
    placeholder="Delivery Cost (₹)"
    className="rounded-3 py-2"
    value={deliveryCost}
    onChange={(e) =>
      setDeliveryCost(
        e.target.value === "" ? "" : Number(e.target.value)
      )
    }
  />
</Col>

       



        </Row>


        <div className="text-start mt-3 py-2">
          {/* <AppButton onClick={handleAdd}></AppButton> */}
          <button type="submit" onClick={handleAdd} className="btn py-2 px-3 btn-primary">Add Material</button>
        </div>
      </div>



      {/* MATERIAL LIST TABLE */}
      <div className="premium-card mt-5">




        <Table bordered responsive className="align-middle custom-material-tableaddmater mb-0 custom-material-table">
          <thead className="table-light">
            <tr>
              <th style={{ width: "80px" }}>Sr. No</th>

              <th>Material</th>
              <th>Price per crown (₹)</th>
               <th>Warranty (Months)</th> 
              <th>DesigningTime</th>
              <th>NESTING + Milling Time</th>
              <th>Processing Time</th>
              <th>Design Cost (₹)</th>
<th>Milling Cost (₹)</th>
<th>Delivery Time</th>
<th>Delivery Cost (₹)</th>
              <th>Delivery Type</th>
              
              <th >Action</th>
            </tr>
          </thead>

          <tbody>

            {materials.length === 0 ? (
              <tr>
              <td colSpan={13} className="text-center text-muted">
                  No Material added yet
                </td>
              </tr>
            ) : (
              materials.map((item, index) => (
                <tr key={item.materialID}>
                  {/* SERIAL NUMBER */}
                  <td>{index + 1}</td>
                  {/* MATERIAL NAME */}
                  <td>
                    {editId === item.materialID ? (
                      <Form.Control
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                      />
                    ) : (
                      <span className="font-weight500">{item.materialName}</span>
                    )}
                  </td>
                  {/* PRICE */}
                  <td>
                    {editId === item.materialID ? (
                      <Form.Control
                        type="number"
                        value={editPrice}
                        onChange={(e) => setEditPrice(Number(e.target.value))}
                      />
                    ) : (
                      <span>₹ {item.price}</span>
                    )}
                  </td>
                  <td>
  {editId === item.materialID ? (
    <Form.Control
      type="number"
      min={0}
      value={editWarrantyMonths}
      onChange={(e) =>
        setEditWarrantyMonths(
          e.target.value === "" ? "" : Number(e.target.value)
        )
      }
    />
  ) : (
    <span>{item.warrantyMonths ?? 0} months</span>
  )}
</td>
                  {/* TURNAROUND TIME */}
                  <td>
                    {editId === item.materialID ? (
                      <>
                        {editUnit === "minutes" ? (
                          <DurationTimePicker
                            value={Number(editDuration) || 0}
                            onChange={(mins) => seteditDuration(String(mins))}
                          />
                        ) : (
                          <Form.Control
                            type="number"
                            value={editDuration}
                            onChange={(e) => seteditDuration(e.target.value)}
                            className="margin-top38"
                          />
                        )}


                      </>
                    ) : (
                      <span>
                        {formatMinutesToHrsMins(Number(item.designingTime))}                        </span>
                    )}
                  </td>

                  <td>
                    {editId === item.materialID ? (
                      <>
                        {editUnit === "minutes" ? (
                          <DurationTimePicker
                            value={Number(editMillingDuration) || 0}
                            onChange={(mins) => seteditMillingDuration(String(mins))}
                          />
                        ) : (
                          <Form.Control
                            type="number"
                            value={editMillingDuration}
                            onChange={(e) => seteditMillingDuration(e.target.value)}
                            className="margin-top38"
                          />
                        )}


                      </>
                    ) : (
                      <span>
                        {formatMinutesToHrsMins(Number(item.millingTime))}
                      </span>
                    )}
                  </td>

                  <td>
                    {editId === item.materialID ? (
                      <>
                        {editUnit === "minutes" ? (
                          <DurationTimePicker
                            value={Number(editProcessingTime) || 0}
                            onChange={(mins) => seteditProcessingTime(String(mins))}
                          />
                        ) : (
                          <Form.Control
                            type="number"
                            value={editProcessingTime}
                            onChange={(e) => seteditProcessingTime(e.target.value)}
                            className="margin-top38"
                          />
                        )}


                      </>
                    ) : (
                      <span>
                        {formatMinutesToHrsMins(Number(item.processingTime))}
                      </span>
                    )}
                  </td>
                  {/* DESIGN COST */}
<td>
  {editId === item.materialID ? (
    <Form.Control
      type="number"
      min={0}
      value={editDesignCost}
      onChange={(e) =>
        setEditDesignCost(
          e.target.value === ""
            ? ""
            : Number(e.target.value)
        )
      }
    />
  ) : (
    <span>
      ₹ {item.designCost ?? 0}
    </span>
  )}
</td>

{/* MILLING COST */}
<td>
  {editId === item.materialID ? (
    <Form.Control
      type="number"
      min={0}
      value={editMillingCost}
      onChange={(e) =>
        setEditMillingCost(
          e.target.value === ""
            ? ""
            : Number(e.target.value)
        )
      }
    />
  ) : (
    <span>
      ₹ {item.millingCost ?? 0}
    </span>
  )}
</td>

{/* DELIVERY TIME */}
<td>
  {editId === item.materialID ? (
    <DurationTimePicker
      value={Number(editDeliverTime) || 0}
      onChange={(mins) => setEditDeliverTime(String(mins))}
    />
  ) : (
    <span>
      {formatMinutesToHrsMins(Number(item.deliverTime))}
    </span>
  )}
</td>

{/* DELIVERY COST */}
<td>
  {editId === item.materialID ? (
    <Form.Control
      type="number"
      min={0}
      value={editDeliveryCost}
      onChange={(e) =>
        setEditDeliveryCost(
          e.target.value === ""
            ? ""
            : Number(e.target.value)
        )
      }
    />
  ) : (
    <span>
      ₹ {item.deliveryCost ?? 0}
    </span>
  )}
</td>


                  <td>
                    {editId === item.materialID ? (
                      <Form.Select
                        value={editOrderTypeId ?? ""}
                        className="hours-selectform"
                        onChange={(e) => setEditOrderTypeId(Number(e.target.value))}
                      >
                        <option value="">Select Order Type</option>
                        {orderTypes.map((ot) => (
                          <option key={ot.orderTypeID} value={ot.orderTypeID}>
                            {ot.orderTypeName}
                          </option>
                        ))}
                      </Form.Select>
                    ) : (
                      <span>{item.orderTypeName}</span>
                    )}
                  </td>



                  {/* ACTION BUTTONS */}
                  <td>
                    {editId === item.materialID ? (
                      <div className="d-flex justify-content-center gap-2">
                        <div



                          className="action-btn delete custom-edit-icon"

                          onClick={handleUpdate}
                        >
                          <i className="bi bi-check-lg" title="Update"></i>
                        </div>

                        <div



                          className="action-btn delete custom-edit-icon"


                          onClick={handleCancel}
                        >
                          <i className="bi bi-x-lg" title="Cancel"></i>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-center gap-2">
                        <div



                          className="action-btn delete custom-edit-icon"

                          onClick={() =>
                            handleEdit(item)
                          }
                        >
                          <i className="bi bi-pencil-square" title="Edit"></i>
                        </div>

                        <div

                          className="action-btn delete custom-edit-icon"
                          onClick={() => confirmDelete(item.materialID)}
                        >
                          <i className="bi bi-trash " title="Delete"></i>
                        </div>

                      </div>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>


      </div>

      {/* DELETE MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Body className="text-center">Are you sure you want to delete this material?</Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button type="button" className="btn py-2 px-3 btn-primary" onClick={handleDelete}>Yes</button>
          {/* <AppButton variant="danger" onClick={handleDelete}>
            Yes
          </AppButton> */}
          {/* <AppButton onClick={() => setShowDeleteModal(false)}>No</AppButton> */}
          <button type="button" onClick={() => setShowDeleteModal(false)} className="btn py-2 px-3 btn-secondary mx-2">No</button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const toDisplayDuration = (duration: number, unit: "minutes" | "days") => {
  return unit === "minutes" ? duration : duration / (24 * 60);
};

const toStorageDuration = (duration: number, unit: "minutes" | "days") => {
  return unit === "minutes" ? duration : duration * 24 * 60;
};

const formatMinutesToHrsMins = (totalMinutes: number) => {
  if (!totalMinutes || totalMinutes <= 0) return "0 mins";

  const hrs = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;

  if (hrs > 0 && mins > 0) return `${hrs} hrs ${mins} mins`;
  if (hrs > 0) return `${hrs} hrs`;
  return `${mins} mins`;
};


const DurationTimePicker = ({
  value,
  onChange,
}: {
  value: number; // total minutes
  onChange: (minutes: number) => void;
}) => {
  const hrs = Math.floor(value / 60);
  const mins = value % 60;

  const updateHours = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newHours = Number(e.target.value);
    onChange(newHours * 60 + mins);
  };

  const updateMinutes = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newMinutes = Number(e.target.value);
    onChange(hrs * 60 + newMinutes);
  };

  return (
    <div className="d-flex  gap-2">
      {/* HOURS */}
      <Form.Select value={hrs} className="hours-selectform" onChange={updateHours}>
        {Array.from({ length: 24 }).map((_, h) => (
          <option key={h} value={h}>
            {h} Hours
          </option>
        ))}
      </Form.Select>

      {/* MINUTES */}
      <Form.Select className="hours-selectform" value={mins} onChange={updateMinutes}>
        {Array.from({ length: 60 }).map((_, m) => (
          <option key={m} value={m}>
            {m} Minutes
          </option>
        ))}
      </Form.Select>
    </div>
  );
};


export default AddMaterial;
